import { render, staticRenderFns } from "./RasmusForgotPasswordForm.vue?vue&type=template&id=3621e7c7&"
import script from "./RasmusForgotPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./RasmusForgotPasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports